import { useState, ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import { ErrorObject } from '../../../types/types';
import { Validator, Validations } from '../../../../utils/validator';

interface Props {
  id: string;
  label: string;
  ariaLabel?: string;
  value: string;
  onValueChanged: (value: string) => void;
  validations?: Validations[];
  validationsPayload?: any;
  variant?: 'standard' | 'filled' | 'outlined' | undefined;
  fullWidth?: boolean;
}

export const CustomTextField = ({
  id,
  label,
  ariaLabel = 'input',
  value,
  onValueChanged,
  validations = [],
  validationsPayload = {},
  variant = 'outlined',
  fullWidth = false
}: Props) => {
  const [error, setError] = useState<ErrorObject>({
    hasError: false,
    message: ''
  });

  const checkValidations = (newValue: string) => {
    const errorData = Validator(newValue, validations, validationsPayload);
    setError(errorData);
  };

  const changeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onValueChanged(newValue);
    checkValidations(newValue);
  };

  const width = fullWidth ? '100%' : 'inherit';

  return (
    <TextField
      id={id}
      label={label}
      value={value}
      aria-label={ariaLabel}
      variant={variant}
      sx={{ width }}
      error={error.hasError}
      helperText={error.message}
      onChange={changeValue}
      required={validations.find((val) => val === 'required') !== undefined}
    />
  );
};
